import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'kui-side-panel-item',
    templateUrl: './side-panel-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KuiSidePanelItemComponent {}
